const MIN_SCREEN_WIDTH = 1200;

export const setupViewport = () => {
  const viewport = document.getElementById('viewport');
  if (!viewport) {
    console.warn("document has not been loaded yet");
    return;
  }
  const defaultViewport = viewport.getAttribute("content");
  const onResize = () => {
    // setup viewport
    if (screen.width < MIN_SCREEN_WIDTH) {
      viewport.setAttribute('content', 'width=' + MIN_SCREEN_WIDTH);
    } else {
      viewport.setAttribute('content', defaultViewport);
    }

    // setup vh for css
    // NOTE: viewportの変更によってwindow sizeの取得値が変わるのでviewport設定後に設定する必要がある
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  onResize();
  window.addEventListener("resize", onResize);
};
